// extracted by mini-css-extract-plugin
export default {"inputContainer":"Radio_inputContainer__8SlwP","likeAnimation":"Radio_likeAnimation__pg1Uq"};